import { useState } from "react";
import { Search, Filter, Star, ChevronDown } from "lucide-react";
import { Avatar, AvatarFallback } from "../ui/avatar";





const universities = ["All Universities", "Baku State University", "ADA University", "Baku Engineering University", "ASOIU", "UNEC"];
const majors = ["All Majors", "Computer Science", "Mathematics", "Physics", "Chemistry", "Business Administration", "Economics", "Electrical Engineering", "Chemical Engineering", "International Relations"];

const allPeople = [
{ id: 1, username: "leyla.m", name: "Leyla Mammadova", initials: "LM", uni: "Baku State University", major: "Computer Science", points: 420, isFriendOfFriend: true },
{ id: 2, username: "rashad.h", name: "Rashad Huseynov", initials: "RH", uni: "ADA University", major: "Computer Science", points: 395, isFriendOfFriend: false },
{ id: 3, username: "nigar.a", name: "Nigar Aliyeva", initials: "NA", uni: "Baku Engineering University", major: "Electrical Engineering", points: 380, isFriendOfFriend: true },
{ id: 5, username: "kamran.h", name: "Kamran Hasanov", initials: "KH", uni: "Baku State University", major: "Computer Science", points: 310, isFriendOfFriend: false },
{ id: 6, username: "sabina.r", name: "Sabina Rzayeva", initials: "SR", uni: "ADA University", major: "Business Administration", points: 290, isFriendOfFriend: true },
{ id: 7, username: "elvin.m", name: "Elvin Mammadov", initials: "EM", uni: "Baku State University", major: "Mathematics", points: 275, isFriendOfFriend: false },
{ id: 8, username: "gulnar.a", name: "Gulnar Aliyeva", initials: "GA", uni: "Baku Engineering University", major: "Chemical Engineering", points: 260, isFriendOfFriend: true },
{ id: 9, username: "farid.g", name: "Farid Guliyev", initials: "FG", uni: "Baku State University", major: "Physics", points: 245, isFriendOfFriend: false },
{ id: 10, username: "aysel.h", name: "Aysel Huseynova", initials: "AH", uni: "ADA University", major: "Economics", points: 230, isFriendOfFriend: true },
{ id: 11, username: "tural.k", name: "Tural Karimov", initials: "TK", uni: "Baku State University", major: "Chemistry", points: 215, isFriendOfFriend: false },
{ id: 12, username: "aynur.m", name: "Aynur Mustafayeva", initials: "AM", uni: "ADA University", major: "International Relations", points: 200, isFriendOfFriend: true }];




const PeopleSearch = ({ onOpenProfile }) => {
  const [query, setQuery] = useState("");
  const [searchMode, setSearchMode] = useState("username");
  const [selectedUni, setSelectedUni] = useState("All Universities");
  const [selectedMajor, setSelectedMajor] = useState("All Majors");
  const [friendOfFriend, setFriendOfFriend] = useState(false);

  const filtered = allPeople.filter((p) => {
    if (query.length > 0) {
      const match = searchMode === "username" ?
      p.username.toLowerCase().includes(query.toLowerCase()) :
      p.name.toLowerCase().includes(query.toLowerCase());
      if (!match) return false;
    }
    if (selectedUni !== "All Universities" && p.uni !== selectedUni) return false;
    if (selectedMajor !== "All Majors" && p.major !== selectedMajor) return false;
    if (friendOfFriend && !p.isFriendOfFriend) return false;
    return true;
  });

  return (
    <div className="space-y-4">
      {/* Search Header */}
      <div className="stat-card !p-4">
        <h2 className="section-title text-base mb-3">Find People</h2>
        <div className="flex gap-2 mb-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={searchMode === "username" ? "Search by username..." : "Search by name surname..."}
              className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-muted border-0 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring" />
            
          </div>
        </div>

        {/* Search mode toggle */}
        <div className="flex items-center gap-2 mb-3">
          <Filter className="w-3.5 h-3.5 text-muted-foreground" />
          <span className="text-xs text-muted-foreground">Search by:</span>
          {["username", "name"].map((mode) =>
          <button
            key={mode}
            onClick={() => setSearchMode(mode)}
            className={`text-xs px-3 py-1.5 rounded-lg font-medium transition-colors ${
            searchMode === mode ?
            "bg-secondary/15 text-secondary" :
            "bg-muted text-muted-foreground hover:text-foreground"}`
            }>
            
              {mode === "username" ? "Username" : "Name & Surname"}
            </button>
          )}
        </div>

        {/* Advanced filters */}
        <div className="flex flex-wrap gap-2">
          {/* University select */}
          <div className="relative">
            <select
              value={selectedUni}
              onChange={(e) => setSelectedUni(e.target.value)}
              className="appearance-none text-xs pl-3 pr-7 py-2 rounded-xl bg-muted text-foreground font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring">
              
              {universities.map((u) =>
              <option key={u} value={u}>{u}</option>
              )}
            </select>
            <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-muted-foreground pointer-events-none" />
          </div>

          {/* Major select */}
          <div className="relative">
            <select
              value={selectedMajor}
              onChange={(e) => setSelectedMajor(e.target.value)}
              className="appearance-none text-xs pl-3 pr-7 py-2 rounded-xl bg-muted text-foreground font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring">
              
              {majors.map((m) =>
              <option key={m} value={m}>{m}</option>
              )}
            </select>
            <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-3 h-3 text-muted-foreground pointer-events-none" />
          </div>

          {/* Friend of friend toggle */}
          <button
            onClick={() => setFriendOfFriend(!friendOfFriend)}
            className={`text-xs px-3 py-2 rounded-xl font-medium transition-colors ${
            friendOfFriend ?
            "bg-secondary/15 text-secondary" :
            "bg-muted text-muted-foreground hover:text-foreground"}`
            }>
            
            Friends of Friends
          </button>
        </div>
      </div>

      {/* Results */}
      {filtered.length === 0 ?
      <div className="stat-card !p-8 text-center">
          <Search className="w-10 h-10 text-muted-foreground/30 mx-auto mb-3" />
          <p className="text-sm font-medium text-foreground">No people found</p>
          <p className="text-xs text-muted-foreground mt-1">Try adjusting your filters</p>
        </div> :

      <div className="space-y-2">
          {filtered.map((person) =>
        <button
          key={person.id}
          onClick={() => onOpenProfile(person.id)}
          className="w-full stat-card !p-4 flex items-center gap-3 text-left hover:shadow-md transition-all">
          
              <Avatar className="w-12 h-12">
                <AvatarFallback className="bg-primary/10 text-primary text-sm font-bold">
                  {person.initials}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-semibold text-foreground">{person.name}</p>
                  {person.isFriendOfFriend &&
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary/10 text-primary font-medium">Friend's friend</span>
              }
                </div>
                <p className="text-xs text-muted-foreground">@{person.username}</p>
                <p className="text-xs text-muted-foreground mt-0.5">{person.major} · {person.uni}</p>
              </div>
              <div className="flex items-center gap-1 px-2.5 py-1 rounded-lg bg-secondary/10">
                <Star className="w-3.5 h-3.5 text-secondary fill-secondary" />
                <span className="text-xs font-bold text-secondary">{person.points}</span>
              </div>
            </button>
        )}
        </div>
      }
    </div>);

};

export default PeopleSearch;